module.exports = __webpack_public_path__ + "static/media/windows.ace9f872.svg";